import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import './../currency-converter.css';
import Popup from 'semantic-ui-react/dist/commonjs/modules/Popup';
import Dropdown from 'semantic-ui-react/dist/commonjs/modules/Dropdown';
import CurrencyField from '../currency-field/CurrencyField';
import { change, Field } from 'redux-form';
import MultipleTransactionInfoContent from '../../multiple-transaction-info-content/MultipleTransactionInfoContent';
import { API_URL } from '../../../utils/config';
import { setReduxFields } from '../../../utils/library';
import { minLength2, maxLength20 } from '../../../utils/validation/index';
import { getPaymentMethodIcon } from '../../../utils/templates/payment-method';
import { getInfoContentConfig } from '../../../utils/multiple-transactions/multiple-transactions';
import { FORMNAME_MULTI_TRANSACTIONS } from '../../../utils/constants';
import './view-for-multiple-transaction.scss';
import { EDIT_ICON_MULTI_TXN_ICON, INFO_TIMELINE_ICON, PREVIEW_NOTE_ICON } from '@Images';

function renderPaymentMethodItems(selected) {
  return ({ key, value, fee_notes, icon_url, display_name }, index) => ({
    key,
    value,
    text: `${'with ' + display_name}`,
    content: (
      <div className="option" key={index}>
        <img
          src={getPaymentMethodIcon(icon_url, selected === value)}
          alt={fee_notes}
          className="icon"
        />
        <div className="title">{display_name}</div>
        <div className="subtitle">{fee_notes}</div>
      </div>
    )
  });
}

class ViewForMultipleTransaction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isNoteModalOpen: false,
      noteValue: ''
    };
    this.sourceCurrencyInfoConfig = [];
    this.destinationCurrencyInfoConfig = [];
  }

  doneNoteAdding = () => {
    if (this.state.noteError) return;
    this.setState({ isNoteModalOpen: false });
    setReduxFields(this.props.dispatch, change, FORMNAME_MULTI_TRANSACTIONS, {
      notes: this.state.noteValue
    });
  };

  handleNoteOpen = () => {
    this.setState({
      isNoteModalOpen: true,
      noteValue: this.props.notes || this.state.notes
    });
  };

  handleNoteClose = () => {
    this.setState({ isNoteModalOpen: false, noteValue: this.props.notes });
  };

  onNoteChange = (e) => {
    const { value } = e.target;
    const noteError = minLength2(value) || maxLength20(value);
    this.setState({ noteValue: e.target.value, noteError });
  };

  componentDidUpdate = () => {
    const {
      source_currency,
      source_amount,
      destination_currency,
      destination_amount,
      instarem_fx_rate,
      net_source_amount
    } = this.props;
    if (this.props.transactionDetails) {
      const { total_fee_amount = 0 } = this.props.transactionDetails;
      const configReqData = {
        source_currency,
        source_amount,
        destination_currency,
        destination_amount,
        instarem_fx_rate,
        transaction_fee_amount: total_fee_amount,
        net_source_amount
      };
      this.sourceCurrencyInfoConfig = getInfoContentConfig('source', configReqData);
      this.destinationCurrencyInfoConfig = getInfoContentConfig('destination', configReqData);
    }
  };

  render() {
    const {
      showLoader,
      source_currency,
      source_amount,
      destination_currency,
      destination_amount,
      instarem_fx_rate,
      total_fee_amount = 0,
      errors: {
        gross_source_amount: source_error = '',
        destination_amount: destination_error = ''
      },
      instarem_bank_account_id,
      dispatch
    } = this.props;
    return [
      <div
        className="currency-field-wrapper multiple-trans-currency-coverter"
        key={'source_currency'}
      >
        <CurrencyField
          {...this.props}
          key={1}
          className="source"
          showLoader={showLoader}
          currencyField="source_currency"
          currency={source_currency}
          amount={source_amount}
          amountField="gross_source_amount"
          // eslint-disable-next-line max-len
          url={`${API_URL}/public/remitter/currencies/dropdown?is_source_currency=true&country_code=${this.props.user_session.country_code}`}
          error={source_error}
          placeholder={'You send'}
          showDefaultPlaceholder={true}
          formName={FORMNAME_MULTI_TRANSACTIONS}
          showDisabledWithIcon={this.props.showDisabledSourceDropdown}
          isSearchable={false}
        />
        <div key={2} className="error source-error">
          {source_error}
        </div>
        <div className="multi-txn-note">
          <div>
            <span>
              Fees <span className="included-text">(included)</span>{' '}
              <span>{`${(total_fee_amount || 0) + ' ' + source_currency}`}</span>
            </span>
          </div>
          <div className="payment-method-wrapper">
            {this.props.viewFor !== 'editTransaction' && (
              <div className="transaction-fee">
                <Field
                  name="instarem_bank_account_id"
                  component={({ input: { value, onBlur } }) => (
                    <Dropdown
                      disabled={this.props.showDisabledSourceDropdown}
                      value={value}
                      options={this.props.bankAccountOptions.map(
                        renderPaymentMethodItems(instarem_bank_account_id)
                      )}
                      placeholder="Select transfer method"
                      className="payment-method"
                      onBlur={onBlur}
                      onChange={(e, { value: instarem_bank_account_id }) =>
                        setReduxFields(dispatch, change, FORMNAME_MULTI_TRANSACTIONS, {
                          instarem_bank_account_id
                        })
                      }
                    />
                  )}
                />
              </div>
            )}
            <Popup
              trigger={
                <img
                  src={INFO_TIMELINE_ICON}
                  alt="info icon"
                  className="info-icon"
                  height="15px"
                  width="15px"
                />
              }
              content={<MultipleTransactionInfoContent config={this.sourceCurrencyInfoConfig} />}
              className="currency-convertor-popup"
              hideOnScroll={false}
              size="huge"
              position="left center"
            />
          </div>
        </div>
      </div>,
      <div
        className="currency-field-wrapper multiple-trans-currency-coverter"
        key={'destination_currency'}
      >
        <CurrencyField
          {...this.props}
          key={4}
          className="destination"
          showLoader={showLoader}
          currencyField="destination_currency"
          // eslint-disable-next-line max-len
          url={`${API_URL}/public/remitter/currencies/dropdown?source_currency=${source_currency}&country_code=${this.props.user_session.country_code}`}
          currency={destination_currency}
          urldependent
          dependedOnObject={source_currency || false}
          amount={destination_amount}
          amountField="destination_amount"
          placeholder={'Recipient receives'}
          formName={FORMNAME_MULTI_TRANSACTIONS}
          showDefaultPlaceholder={true}
          showDisabledWithIcon={this.props.showDisabledDestinationDropdown}
          error={destination_error}
        />
        <div key={5} className="error destination-error">
          {destination_error}
        </div>
        <div className="multi-txn-note add-note-with-note">
          <div className="rate-wrapper">
            <span>{`@1 ${source_currency} = ${
              instarem_fx_rate + ' ' + destination_currency
            }`}</span>
            <Popup
              trigger={<img src={INFO_TIMELINE_ICON} alt="info icon" className="info-icon" />}
              content={
                <MultipleTransactionInfoContent
                  config={this.destinationCurrencyInfoConfig}
                  viewFor={'destination'}
                />
              }
              className="currency-convertor-popup"
              hideOnScroll={false}
              size="huge"
              position="left center"
            />
          </div>
          {this.props.viewFor !== 'editTransaction' && (
            <div className="add-note-wrapper">
              <div className="icon-add-note-wrapper">
                <Popup
                  trigger={
                    this.props.notes ? (
                      <div className="note-trigger">
                        <img
                          className="add-a-note-icon"
                          src={PREVIEW_NOTE_ICON}
                          alt="preview note"
                        />
                        <span className="add-a-note">Preview a note</span>
                      </div>
                    ) : (
                      <div className="note-trigger">
                        <img
                          className="add-a-note-icon"
                          src={EDIT_ICON_MULTI_TXN_ICON}
                          alt="add note"
                        />
                        <span className="add-a-note">Add a note</span>
                      </div>
                    )
                  }
                  content={
                    <div className="add-note-modal">
                      <input
                        placeholder="type your note"
                        className="add-note-input"
                        type="text"
                        name="notes"
                        onChange={this.onNoteChange}
                        value={this.state.noteValue}
                      />
                      <button onClick={this.doneNoteAdding} className="add-note-done">
                        Done
                      </button>
                      <span className="add-note-error">{this.state.noteError}</span>
                    </div>
                  }
                  className="add-note-popup"
                  hideOnScroll={false}
                  on="click"
                  size="mini"
                  open={this.state.isNoteModalOpen}
                  onOpen={this.handleNoteOpen}
                  onClose={this.handleNoteClose}
                  position="bottom left"
                />
              </div>
              {!this.props.notes && <span className="optional">(optional)</span>}
            </div>
          )}
        </div>
      </div>
    ];
  }
}

ViewForMultipleTransaction.propTypes = {
  showLoader: PropTypes.bool,
  user_session: PropTypes.object,
  source_currency: PropTypes.string,
  onSourceAmountChange: PropTypes.func,
  destination_currency: PropTypes.string,
  source_amount: PropTypes.any,
  onSourceCurrencyChange: PropTypes.func,
  onDestinationAmountChange: PropTypes.func,
  onDestinationCurrencyChange: PropTypes.func,
  DestinationErr: PropTypes.string,
  sourceErr: PropTypes.string,
  urldependent: PropTypes.bool,
  destination_amount: PropTypes.any,
  instarem_fx_rate: PropTypes.number,
  transaction_fee_amount: PropTypes.number,
  errors: PropTypes.any,
  instarem_bank_account_id: PropTypes.number,
  dispatch: PropTypes.func,
  showDisabledSourceDropdown: PropTypes.bool,
  bankAccountOptions: PropTypes.array,
  showDisabledDestinationDropdown: PropTypes.bool,
  saveNote: PropTypes.func,
  viewFor: PropTypes.string,
  notes: PropTypes.any,
  net_source_amount: PropTypes.any,
  transactionDetails: PropTypes.object,
  total_fee_amount: PropTypes.any
};

function mapStateToProps(reduxState) {
  const {
    rootReducer: {
      transactionReducer: {
        currencyCovertor: { is_destination_amount_last_changed, sourceErr, DestinationErr },
        transactionDetails: { total_fee_amount }
      }
    }
  } = reduxState;
  return {
    is_destination_amount_last_changed,
    sourceErr,
    DestinationErr,
    total_fee_amount
  };
}

export default connect(mapStateToProps, {})(ViewForMultipleTransaction);
